<template>
  <model-table
    :collection="tipPoolTypes"
    :columns="[
      { field: 'id' },
      { field: 'name' },
      { name: 'employeeJobTypes', field: tipPoolType => $_.map(tipPoolType.employeeJobTypes.data, employeeJobType => employeeJobType.name), component: 'chips', limitValues: 4 },
      { name: 'strategy', field: tipPoolType => $_.startCase(tipPoolType.distributionStrategy), component: 'chip' },
      { name: 'schedule', field: tipPoolType => $_.startCase(tipPoolType.distributionSchedule), component: 'chip' },
      { name: 'library', component: 'library-link', hide: currentCircuit.isLibrary },
      { name: 'actions', label: 'Action', align: 'right' }
    ]"
    :has-library="!currentCircuit.isLibrary"
    :library-collection="tipPoolTypeLibrary"
    :library-columns="[
      { field: 'id' },
      { field: 'name' },
      { name: 'employeeJobTypes', field: tipPoolType => $_.map(tipPoolType.employeeJobTypes.data, employeeJobType => employeeJobType.name), component: 'chips', limitValues: 4 },
      { name: 'strategy', field: tipPoolType => $_.startCase(tipPoolType.distributionStrategy), component: 'chip' },
      { name: 'schedule', field: tipPoolType => $_.startCase(tipPoolType.distributionSchedule), component: 'chip' }
    ]"
    :link-filter="libraryFilterFunction"
  >
    <tip-pool-type-form />
  </model-table>
</template>

<script>
import ModelTable from 'src/modules/admin/components/ModelTable'
import TipPoolTypeForm from 'src/modules/admin/tip/TipPoolTypeForm'

export default {
  name: 'TipPoolTypeTable',
  components: {
    ModelTable,
    TipPoolTypeForm
  },
  configuration: ['currentCircuit'],
  models: {
    tipPoolTypes: {
      employeeJobTypes: {
        fields: ['id', 'name']
      },
      libraryParentId: true,
      receiveLibraryUpdates: true
    },
    tipPoolTypeLibrary: {
      libraryChildSiteIds: true,
      employeeJobTypes: {
        fields: ['id', 'name']
      },
      variables () {
        return {
          searchString: this.libraryFilterString,
          limit: 10
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      libraryFilterString: null
    }
  },
  methods: {
    libraryFilterFunction (value) {
      this.libraryFilterString = !_.isEmpty(value) ? value.trim() : null
    }
  }
}
</script>
